import React from 'react';
import sprintf from 'sprintf';

class SMReservationCalendarBaseView extends React.Component {

  constructor(props) {
    super(props);

    if (props.calendarState != null) {
      this.state = {
        monthlyCalendars: props.calendarState.monthlyCalendars,
        dailyCalendars: props.calendarState.dailyCalendars,
        selectedDate: props.calendarState.selectedDate,
        year: props.calendarState.year,
        month: props.calendarState.month,
        day: props.calendarState.day,
      };
    } else {
      const date = new Date();
      this.state = this.resetState(date);
    }

    this.nextMonth = this.nextMonth.bind(this);
    this.prevMonth = this.prevMonth.bind(this);
  }

  componentDidMount() {
    const date = new Date();
    if (this.props.calendarState == null) {
      this.requestMonthlyResource(date);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.plan != this.props.plan || prevProps.isHourly != this.props.isHourly) {
      const date = new Date();
      this.setState(this.resetState(date));
      this.requestMonthlyResource(date);
    }
  }

  resetState(date) {
    return {
      monthlyCalendars: [],
      dailyCalendars: [],
      selectedDate: null,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: null,
    };
  }

  toYMD(date, divider) {
    divider = divider || "";
    var y = date.getUTCFullYear(),
        m = date.getUTCMonth() + 1,
        d = date.getUTCDate();
    return sprintf("%04d%s%02d%s%02d", y, divider , m , divider , d);
  }

  nextMonth(e) {
    e.preventDefault();
    var date = new Date(
      this.state.year,
      this.state.month,
      1
    );
    this.requestMonthlyResource(date);
  }

  prevMonth(e) {
    e.preventDefault();
    const date = new Date(
      this.state.year,
      this.state.month - 2,
      1
    );
    this.requestMonthlyResource(date);
  }

  nextDay(e) {
    e.preventDefault();
  }

  prevDay(e) {
    e.preventDefault();
  }

}
export default SMReservationCalendarBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationCalendarBaseView.jsx